<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6">
                    <h2>Política de Privacidad</h2>
                </div>

                <div class="col-lg-6 col-md-6">
                    <ul>
                        <li><a routerLink="/">Inicio</a></li>
                        <li>Política de Privacidad</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="terms-conditions ptb-100">
    <div class="container">
        <div class="single-privacy">
            <h2>enCloud®</h2>
            <p><strong>Última actualización:</strong> 12 de Noviembre del 2024</p>

            <h3>1. Introducción</h3>
            <p>En enCloud®, nos comprometemos a proteger y respetar la privacidad de nuestros usuarios, empleados y
                clientes. Esta Política de Privacidad establece cómo recopilamos, utilizamos, compartimos y protegemos
                la información personal obtenida a través de nuestros servicios de computación en la nube,
                almacenamiento de datos, hosting de servidores dedicados, servidores para videojuegos y machine
                learning.

                Queremos que nuestros usuarios se sientan seguros al utilizar nuestros servicios, por lo que nos
                adherimos a las leyes mexicanas de protección de datos personales y a los más altos estándares de
                privacidad.
            </p>

            <h3>2. Responsable del Tratamiento de Datos</h3>
            <p>
                ENCLOUD® S.A. de C.V., con domicilio en [Dirección de ENCLOUD®], México, es el responsable del
                tratamiento de sus datos personales. Nos comprometemos a manejarlos de manera confidencial y con el
                nivel de seguridad requerido por la ley.

                Si tiene alguna pregunta o desea ejercer sus derechos relacionados con el tratamiento de sus datos
                personales, puede contactarnos a través de nuestra página de <a
                    routerLink="/contact"><strong>contacto</strong></a>.

            </p>

            <h3>3. Datos que Recopilamos</h3>
            <h4>3.1 Datos Personales</h4>
            <p>Cuando se registre y utilice nuestros servicios, podremos recopilar la siguiente información:</p>
            <ul>
                <li><strong>Datos de Identificación:</strong> Nombre completo, dirección de correo electrónico, número
                    de teléfono y dirección física.</li>
                <li><strong>Datos Financieros:</strong> Información de pago, como números de tarjetas de crédito/débito, dirección de facturación y cualquier otro dato necesario para procesar pagos.</li>
                <li><strong>Datos de Contacto:</strong> Teléfono, correo electrónico y dirección física (cuando sea necesario para facturación).</li>
                <li><strong>Datos Demográficos:</strong> Información que nos ayuda a personalizar la experiencia, como el sector en el que opera su empresa o el tipo de servicios requeridos.</li>
            </ul>

            <h4>3.2 Datos de Uso</h4>
            <p>También recopilamos datos técnicos y de uso, tales como:</p>
            <ul>
                <li><strong>Datos de Acceso:</strong> Direcciones IP, tipo de dispositivo, navegador, sistema operativo,
                    fechas y horas de acceso, y otras estadísticas relacionadas con su interacción con nuestros
                    servicios.</li>
                <li><strong>Información de Navegación:</strong> Cookies y tecnologías similares que nos permiten analizar la interacción del usuario con nuestra plataforma.</li>
                <li><strong>Registro de Actividad:</strong> Acciones realizadas en servidores, configuraciones de servicios, solicitudes de soporte, entre otras interacciones con nuestros servicios.</li>
            </ul>

            <h3>4. Finalidad del Tratamiento de Datos</h3>
            <p>Los datos que recopilamos son utilizados para los siguientes fines:</p>
            <ul>
                <li><strong>Provisión y gestión de servicios:</strong> Para crear, administrar y ofrecer nuestros servicios de computación en la nube, almacenamiento, hosting y machine learning.</li>
                <li><strong>Procesamiento de pagos:</strong> Para procesar pagos, facturación y otras transacciones
                    financieras necesarias para la prestación de nuestros servicios.</li>
                <li><strong>Soporte al cliente:</strong> Para proporcionar soporte técnico, atención al cliente y
                    gestionar cualquier consulta o reclamo relacionado con nuestros servicios.</li>
                <li><strong>Mejoras y personalización:</strong> Para optimizar la experiencia del usuario y personalizar
                    el uso de nuestros servicios, adaptando nuestras soluciones a las necesidades específicas de
                    nuestros clientes.</li>
                <li><strong>Cumplimiento de obligaciones legales:</strong> Para cumplir con las leyes y regulaciones
                    locales, como la <strong>Ley Federal de Protección de Datos Personales en Posesión de los
                        Particulares</strong>, y otras normativas aplicables en México.</li>
                <li><strong>Investigación y desarrollo:</strong> Para realizar investigaciones internas, análisis de
                    datos, y desarrollar nuevos productos y servicios, con el fin de mejorar nuestra oferta tecnológica.
                </li>
            </ul>

            <h3>5. Uso de Cookies y Tecnologías Similares</h3>
            <p>Utilizamos cookies y tecnologías similares (como balizas web) para recopilar información sobre cómo
                interactúa con nuestros servicios, mejorar su experiencia y personalizar el contenido. Las cookies nos
                ayudan a reconocer su dispositivo y proporcionarle una experiencia de usuario más fluida. Puede
                configurar su navegador para que no acepte cookies, pero esto puede afectar algunas funcionalidades de
                nuestro sitio y servicios. Consulte nuestra <a routerLink="/cookies-policy"> <strong> Política de
                    Cookies</strong></a> para obtener más detalles sobre cómo gestionamos estas tecnologías.</p>

            <h3>6. Terceros con Acceso a los Datos</h3>
            <p>enCloud® bajo ninguna manera vende o alquila sus datos personales. Sin embargo, podemos compartirlos con
                terceros de confianza que colaboran con nosotros para el funcionamiento de nuestros servicios, siempre
                con medidas de seguridad y privacidad adecuadas. Estos terceros incluyen:</p>
            <ul>
                <li><strong>Proveedores de servicios financieros:</strong> Como plataformas de pago o bancos para
                    procesar transacciones.</li>
                <li><strong>Autoridades gubernamentales y organismos reguladores:</strong> Para cumplir con las leyes y
                    regulaciones mexicanas, especialmente en casos de auditorías o investigaciones legales.</li>
            </ul>
            <p>Nos aseguramos de que todas las transferencias de datos se realicen bajo condiciones que garanticen su
                seguridad y privacidad.</p>

            <h3>7. Seguridad de la Información</h3>
            <p>La seguridad de sus datos personales es una de nuestras principales prioridades. Adoptamos una serie de
                medidas de seguridad técnicas, físicas y administrativas para proteger sus datos de acceso no
                autorizado, pérdida o destrucción. Entre las medidas implementadas se encuentran:</p>
            <ul>
                <li><strong>Encriptación de datos:</strong> Usamos protocolos de encriptación para proteger la
                    información durante su transmisión.</li>
                <li><strong>Autenticación y control de acceso:</strong> Solo el personal autorizado puede acceder a sus
                    datos personales y para fines específicos.</li>
                <li><strong>Monitorización y auditoría:</strong> Implementamos sistemas para monitorizar el acceso a la
                    información y detectar cualquier actividad sospechosa.</li>
            </ul>

            <h3>8. Derechos ARCO (Acceso, Rectificación, Cancelación y Oposición)</h3>
            <p>De acuerdo con la <strong>Ley Federal de Protección de Datos Personales en Posesión de los
                    Particulares</strong>, usted tiene los siguientes derechos sobre sus datos personales:</p>
            <ul>
                <li><strong>Acceso:</strong> Tiene derecho a conocer qué datos personales tenemos sobre usted y cómo los
                    estamos utilizando.</li>
                <li><strong>Rectificación:</strong> Puede solicitar la corrección de sus datos personales si son
                    inexactos o están incompletos.</li>
                <li><strong>Cancelación:</strong> Puede solicitar la eliminación de sus datos personales cuando
                    considere que ya no son necesarios para los fines para los que fueron recopilados.</li>
                <li><strong>Oposición:</strong> Puede oponerse al tratamiento de sus datos personales para fines
                    específicos, como la comercialización o personalización.</li>
            </ul>
            <p>Para ejercer estos derechos, deberá enviar una solicitud clara a través de nuestra página de <a
                    routerLink="/contact"><strong>contacto</strong></a> con su nombre, datos de contacto y el derecho
                que desea ejercer. También puede contactarnos para obtener más información sobre el proceso de ejercicio
                de estos derechos.</p>

            <h3>9. Transferencias Internacionales de Datos</h3>
            <p>enCloud® no realiza transferencias de datos fuera de México sin su consentimiento expreso, salvo en los
                casos en que la ley nos obligue a hacerlo o cuando sea necesario para la prestación de los servicios.
                Cuando realizamos transferencias internacionales de datos, tomamos medidas para garantizar que se
                mantenga el nivel adecuado de protección de la información.</p>

            <h3>10. Retención de Datos</h3>
            <p>Los datos personales que recopilamos se conservarán solo durante el tiempo necesario para cumplir con los
                fines establecidos en esta Política de Privacidad, o para cumplir con nuestras obligaciones legales y
                regulatorias. Una vez que sus datos ya no sean necesarios, serán eliminados o anonimizados de acuerdo
                con nuestros procedimientos internos.</p>

            <h3>11. Modificaciones a esta Política de Privacidad</h3>
            <p>enCloud® se reserva el derecho de modificar esta Política de Privacidad en cualquier momento. Cualquier
                cambio será publicado en esta página, y la fecha de la última actualización será indicada al inicio del
                documento. Le recomendamos revisar esta página periódicamente para mantenerse informado sobre nuestras
                prácticas de privacidad.</p>

            <h3>12. Contacto</h3>
            <p>Si tiene alguna pregunta o inquietud acerca de esta Política de Privacidad, o si desea ejercer sus
                derechos ARCO, no dude en contactarnos a través de nuestra página de <a
                    routerLink="/contact"><strong>contacto</strong></a>.</p>
        </div>
    </div>
</section>